import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=f897d93a&scoped=true&lang=pug&"
import script from "./Step3.vue?vue&type=script&lang=js&"
export * from "./Step3.vue?vue&type=script&lang=js&"
import style0 from "../Onboarding.scss?vue&type=style&index=0&id=f897d93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f897d93a",
  null
  
)

export default component.exports